import React, { useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getDescriptorManual } from "../../redux/descriptorsProfiles/GeneralInfo/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const LinkDescargaDescriptor = (props) => {
  //*states
  const [loader, setLoader] = useState(false);

  const history = useHistory();
  //*variables
  const dispatch = useDispatch();
  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip {...props}>Descargar descriptor</Tooltip>}
    >
      <Button
        size="sm"
        className="text-secondary rounded"
        variant="link"
        type="button"
        onClick={() => {
          // dispatch(
          //   getDescriptorManual(
          //     props.id,
          //     props.nombre_posicion,
          //     setLoader,
          //     history
          //   )
          // )
          const newWindow = window.open("", "_blank");

          // Update the URL in the new window or tab
          newWindow.location.href = `/descriptores-perfiles/descargar-descriptor/${props.id}/${props.nombre_posicion}`;
        }}
        disabled={loader}
      >
        {loader ? (
          <Spinner
            className="ml-2"
            animation="border"
            variant="primary"
            size="sm"
          />
        ) : (
          <i className="material-icons">download</i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

export default LinkDescargaDescriptor;
